import { render, staticRenderFns } from "./customCostPayRatioControl.vue?vue&type=template&id=326a5b9c&scoped=true&"
import script from "./customCostPayRatioControl.vue?vue&type=script&lang=js&"
export * from "./customCostPayRatioControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326a5b9c",
  null
  
)

export default component.exports